import { render } from "./GalleryItem.vue?vue&type=template&id=492c134d&scoped=true"
import script from "./GalleryItem.vue?vue&type=script&lang=js"
export * from "./GalleryItem.vue?vue&type=script&lang=js"

import "./GalleryItem.vue?vue&type=style&index=0&id=492c134d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492c134d"]])

export default __exports__